module.exports = __webpack_public_path__ + "static/media/nicole.a9f886a2.png";